define('model/disclosure.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var DisclosureModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureModel': '@constructor',
    },

    useHalSelfLinkAsUrl: false,

    urlRoot: '/api/v1/compliance/disclosure',
  });

  module.exports = DisclosureModel;
});

